import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { RespondContainer } from '../Respond';

import { SideClosedContainer } from './SideClosed';
import { SideSignedContainer } from './SideSigned';
import { SideUnsignedContainer } from './SideUnsigned';
import { SideVictoryContainer } from './SideVictory';

function SideContainerInner(): JSX.Element {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker, signed },
	} = usePetitionDetailsPageUserData();

	if (decisionMaker) {
		return <RespondContainer />;
	}
	if (status === 'CLOSED') {
		return <SideClosedContainer />;
	}
	if (status === 'VICTORY') {
		return <SideVictoryContainer />;
	}
	if (signed) {
		// TODO: Show share buttons for victory, closed, starter, non-promotablee
		return <SideSignedContainer />;
	}
	return <SideUnsignedContainer />;
}

type Props = {
	containerRef?: React.RefObject<HTMLElement>;
};

export function SideContainer({ containerRef }: Props): JSX.Element {
	return (
		<Box
			ref={containerRef}
			px={24}
			pb={24}
			mt={8}
			pt={24}
			sx={{
				height: '100%',
				borderRadius: '8px',
				borderColor: 'primary-greyBackground',
				boxShadow: '0px 0px 16px 0px #00000026',
				backgroundColor: 'white',
			}}
		>
			<SideContainerInner />
		</Box>
	);
}
